import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sum',
  pure: true
})
export class SumPipe implements PipeTransform {
  transform(items: any[], prop: string): number {
    if (!items || !prop) return 0;
    
    return items.reduce((a, b) => {
      if (prop.includes('/')) {
        // Handle division operations
        const [numerator, denominator] = prop.split('/');
        const num = this.getPropertyValue(b, numerator);
        const den = this.getPropertyValue(b, denominator);
        return a + (den !== 0 ? num / den : 0);
      } else {
        // Handle regular properties
        return a + (this.getPropertyValue(b, prop) || 0);
      }
    }, 0);
  }

  private getPropertyValue(obj: any, path: string): number {
    return path.split('.').reduce((o, i) => o?.[i], obj) || 0;
  }
}